export default "__VITE_ASSET__bkSeInid__"